// extracted by mini-css-extract-plugin
module.exports = {"form":"FormPlayers_form__24LJ-","formLive":"FormPlayers_formLive__1sCYT","formColumn":"FormPlayers_formColumn__1R4tB"};